import React from 'react';
import { Icon, S } from 'design-system-web';
import cx from 'classnames';
import styles from './Alert.scss';

export enum AlertType {
  error = 'error',
  warning = 'warning',
  success = 'success',
  info = 'info',
}

type AlertProps = {
  type: AlertType | `${AlertType}`;
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

const iconName: { [key in AlertType]: string } = {
  [AlertType.error]: 'times-circle',
  [AlertType.warning]: 'exclamation-triangle',
  [AlertType.success]: 'check-circle',
  [AlertType.info]: 'info-circle',
};

export function Alert({
  type,
  fullWidth = false,
  children,
  className,
  style,
}: AlertProps) {
  return (
    <div
      data-test="alert"
      className={cx(
        styles.alert,
        fullWidth && styles.fullWidth,
        styles[type],
        className
      )}
      style={style}
    >
      <div className={cx(styles.iconWrapper, styles[type])}>
        <Icon
          name={iconName[type]}
          type="far"
          className={styles.icon}
        />
      </div>
      <div className={cx(styles.content)}>
        {typeof children === 'string' ? <S>{children}</S> : children}
      </div>
    </div>
  );
}